/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-28 21:33:13
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-08 18:04:34
 */
import { getNoticeList, getMessageList } from '@/server/message'
import { getWebhookStatus } from '@/server/shopList'
import { getSyncCount } from '@/server/album'
import { _local } from '@/utils/storage'
export default {
    state: {
        messageList: [], // 系统消息
        noticeList: [], // 官方公告
        messageNum: 0,
        noticeNum: 0,
        syncShopId: null,
        albumSyncNum: 0, // 可同步专辑数量
        newNotice: null
    },
    getters: {
        getCount(state) {
            return state.noticeNum + state.messageNum
        }
    },
    mutations: {
        'message.noticeList'(state, data) {
            state.noticeList = data
        },
        'message.messageList'(state, data) {
            state.messageList = data
        },
        'message.messageNum'(state, data) {
            state.messageNum = data
        },
        'message.noticeNum'(state, data) {
            state.noticeNum = data
        },
        setSyncShopId(state, data) {
            state.syncShopId = data
        },
        setAlbumSyncNum(state, data) {
            state.albumSyncNum = data
        },
        setNewNotice(state, data) {
            state.newNotice = data
        }
    },
    actions: {
        async getNoticeList(store, params = {}) {
            getNoticeList({ pageNum: 1, pageSize: 2 }).then(res => {
                if (res.data.code === 0) {
                    store.commit('message.noticeList', res.data.data.items)
                }
            })
            getNoticeList({ status: 0, pageNum: 1, pageSize: 2 }).then(res => {
                if (res.data.code === 0) {
                    store.commit('message.noticeNum', res.data.data.totalCount)
                }
            })

        },
        getMessageList(store, params = {}) {
            getMessageList({ pageNum: 1, pageSize: 2, merchantId: _local.get('merchantId') }).then(res => {
                if (res.data.code === 0) {
                    store.commit('message.messageList', res.data.data.items)
                }
            })
            getMessageList({ pageNum: 1, pageSize: 2, status: 0, merchantId: _local.get('merchantId') }).then(res => {
                if (res.data.code === 0) {
                    store.commit('message.messageNum', res.data.data.totalCount)
                    // // 判断列表是否有webhook异常，如果有则查询列表
                    if (res.data.data.items && res.data.data.items.some(el => el.type === 2)) {
                        store.dispatch('checkWebHook')
                    }
                }
            })

        },
        checkWebHook(store, params = {}) {
          if (_local.get('merchantId')) {
              getWebhookStatus().then(res => {
                if (res.data.code === 0) {
                    store.commit('menu.setWebHookList', res.data.data)
                }
            })
          }
           

        },
        getAlbumSyncNum(store, params = {}) {
            getSyncCount().then(res => {
                if (res.data.code === 0) {
                    store.commit('setAlbumSyncNum', res.data.data)
                }
            })
        }
    }
}
